module.exports = __webpack_public_path__ + "media/src/images/balloons/banner_courses_easter_en-ba8bbdd0ef50de3cb5cc4461f615296d.png";